var map = {
	"./Donald.png": 7417,
	"./Mickey.png": 2952,
	"./Minnie.png": 6567,
	"./Mulan.png": 3744,
	"./Olaf.png": 8991,
	"./Simba.png": 5595,
	"./Stitch.png": 207,
	"./TinkerBell.png": 3248,
	"./phyLogo.png": 8667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;